import { render, staticRenderFns } from "./searchPlus.vue?vue&type=template&id=0c4e501e&scoped=true"
import script from "./searchPlus.vue?vue&type=script&lang=js"
export * from "./searchPlus.vue?vue&type=script&lang=js"
import style0 from "./searchPlus.vue?vue&type=style&index=0&id=0c4e501e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4e501e",
  null
  
)

export default component.exports